import React from 'react';
import Input from 'components/General/Form/Input';
import Search from "@material-ui/icons/Search"
import RoundedButton from 'components/General/Form/CustomButton/RoundedButton';
import * as CONSTANT from "constants/text";
import "./SearchNewFriends.css"


class SearchNewUsers extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            username: "",
        };

        /*function binding*/
        this.onSearch = this.onSearch.bind(this);
        this.onUserNameChange = this.onUserNameChange.bind(this)
    }

    onUserNameChange(e){
        this.setState({ username: e.target.value });

        if (this.props.placeholder === CONSTANT.FIND_YOUR_FRIENDS){
            //This lets the list reset without a search click, and
            //will show all friends as soon when the search field is cleared by the user.
            if (e.target.value === ""){
                this.props.searchResultHandler(e.target.value);
            }
        }
    }

    onSearch(e){
        if(this.props.placeholder === CONSTANT.FIND_NEW_FRIENDS){
            //just like in ImageFriends.js. The search handler is a prop.
            this.props.searchResultHandler([CONSTANT.USERNAME, this.state.username]);
        }
        else if(this.props.placeholder === CONSTANT.FIND_NEW_MEMBERS){
            //just like in ImageFriends.js. The search handler is a prop.
            this.props.searchResultHandler([CONSTANT.NEW_MEMBERS, this.state.username]);
        }
        else if(this.props.placeholder === CONSTANT.FIND_NEW_GROUPS){
            //just like in ImageFriends.js. The search handler is a prop.
            this.props.searchResultHandler([CONSTANT.GROUPS, this.state.username]);
        }
        else {
            //just like in ImageFriends.js. The search handler is a prop.
            this.props.searchResultHandler(this.state.username);
        }
    }


    render() {
        return (
        <div>
            <div className="search_components_columns">
                <div className="search_field">
                    <Input
                        name ="search_username"
                        inputType = "username"
                        value = {this.state.username}
                        placeholder = {this.props.placeholder}
                        handleChange = {this.onUserNameChange}
                        width = "100%"
                    />
                </div>
                <div className="search_button">
                        <RoundedButton
                            startIcon = {<Search style={{fontSize: 25, color: "white"}} />}
                            handleOnClick = {this.onSearch}
                            title = {CONSTANT.SEARCH}
                            textThemeClassName = "text_small text_white"
                            buttonClassName = "background_light_med_grey"
                            float = "none"
                            borderRadius="6px"
                        />
                </div>
            </div>
        </div>
        );
    }

}

export default SearchNewUsers;